const Pages = {
    Category: 'category',
    Checkout: 'checkout',
    Product: 'product',
    Home: 'home',
    Subcategory: 'subcategory',
};

export default Pages;
